import NotificationsModule from './notifications'
import ModalsModule from './modals'
import MenusModule from './menus'
import WorkroomModule from './workroom'
import CommentsModule from './comments'
import PaymentsModule from './payments'
import ProjectDashboardModule from './project-dashboard'
import ProjectBrowseModule from './project-browse'
import ExpertProfileModule from './expert-profile'
import SystemReloadModule from './system-reload'
import SettingsModule from './settings'
import TransactionsModule from './transactions'
import HeaderModule from './header'
import ProjectPresetsModule from './project-presets'
import AttachmentsModule from './attachments'
import SubmissionFirstprojectModule from './project-submission/submission-firstproject'
import CouponService from './../common/services/coupon.service'
import SubmissionStepHeaderSubjectFilter from './projectSubmissionStepHeaderSubject.filter'


const ComponentsModule = angular.module('app.components', [
  NotificationsModule,
  ModalsModule,
  MenusModule,
  WorkroomModule,
  CommentsModule,
  PaymentsModule,
  ProjectDashboardModule,
  ProjectBrowseModule,
  ExpertProfileModule,
  SystemReloadModule,
  SettingsModule,
  TransactionsModule,
  HeaderModule,
  ProjectPresetsModule,
  AttachmentsModule,
  SubmissionFirstprojectModule
])
  .service('CouponService', CouponService)
  .filter('submissionStepHeaderSubjectFilter', SubmissionStepHeaderSubjectFilter)
  .name

export default ComponentsModule
